import React from 'react';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import { VIEW_KIND_TREE } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { fg } from '@atlassian/jira-feature-gating';
import { defineMessage, useIntl } from '@atlassian/jira-intl';
import { useIsViewKindLocked } from '../../../common/utils/useIsViewKindLocked.tsx';

const newLozenge = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.tree-view-new-lozenge',
	defaultMessage: 'New',
	description: 'Lozenge label indicating Tree view is a new feature',
});

const premiumLozenge = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.premium-lozenge',
	defaultMessage: 'Premium',
	description: 'Lozenge label indicating the view is a premium feature',
});

export const ViewItemIconAfter = ({
	viewKind,
}: {
	viewKind: ViewKind;
}): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const isViewKindLocked = useIsViewKindLocked();

	if (isViewKindLocked(viewKind) && fg('jpd_tree-view-standard-upgrade')) {
		return <Lozenge appearance="discovery">{formatMessage(premiumLozenge)}</Lozenge>;
	}

	if (viewKind === VIEW_KIND_TREE) {
		return <Lozenge appearance="discovery">{formatMessage(newLozenge)}</Lozenge>;
	}

	return null;
};
